import type { ApiError } from '@/shared/api';

/** Der Server zeigt nur Tage bis 366 Tage vor oder zurück (UTC); einen Tag Puffer für die Objektzeit. */
export const DAY_RANGE = 365;

const KNOWN: Record<string, string> = {
  operations_date_invalid: 'Der Server zeigt nur Tage bis ein Jahr vor oder zurück.',
  operations_timezone_invalid:
    'Die Zeitzone des Objekts ist ungültig. Bitte in den Objektdaten prüfen.',
};

/**
 * Was der Server zu einem Fehler sagt, auf Deutsch. Der Tagesendpunkt schickt nur Codes im Titel
 * oder gar keinen Text; ohne Übersetzung bliebe der Grund unsichtbar.
 */
export function heuteProblemText(problem: ApiError | null): string | null {
  if (!problem) return null;
  const known = KNOWN[problem.title];
  if (known) return known;
  if (problem.status === 403) return 'In diesem Objekt sehen Sie keine Apartments.';
  if (problem.status === 404) return 'Dieses Objekt gibt es nicht mehr.';
  if (problem.detail) return problem.detail;
  return problem.status >= 500 ? `Der Server meldet einen Fehler (${problem.status}).` : null;
}

/** Fehler, die ein erneuter Versuch nicht behebt; ihr alter Stand wird auch nicht mehr gezeigt. */
export function isFinalProblem(problem: ApiError | null): boolean {
  return problem !== null && [400, 403, 404, 409].includes(problem.status);
}
